import type { FavoriteProduct } from 'favorite/types/types'

export const addNewFavorite = (
	favorites: FavoriteProduct[] | undefined,
	product: FavoriteProduct
): FavoriteProduct[] =>
	favorites ? [...favorites, { ...product }] : [{ ...product }]
